import React, { type FunctionComponent } from 'react'
import { Box } from 'legacy/dash-blocks/box/Box'
import { type RetailerRouteComponentProps } from 'legacy/components/RetailerRoute'
import Link from 'legacy/components/Link'
import withRetailerRouter from 'legacy/common/withRouter'

interface Props extends RetailerRouteComponentProps {
  orderDeliveryId: number
  orderId: number
}

export const _OrdersListTableOrderCell: FunctionComponent<Props> = ({
  orderId,
  orderDeliveryId,
  url,
}) => {
  const orderUrl = url('order', { order_delivery_id: orderDeliveryId.toString() })

  return (
    <Box>
      <Link to={orderUrl}>{orderId}</Link>
    </Box>
  )
}

export const OrdersListTableOrderCell = withRetailerRouter(_OrdersListTableOrderCell)
